// async function getCollectionProducts(handle) {
//     const query = `
//     query TestProductMetafields($handle: String!) {
//   product(handle: $handle) {
//     id
//     title

//     collectionDesc: metafield(namespace: "custom", key: "collection_desc") {
//       id
//       namespace
//       key
//       type
//       value
//     }
//     collectionHair: metafield(namespace: "custom", key: "collection_hair") {
//       id
//       namespace
//       key
//       type
//       value
//     }
//     collectionImg: metafield(namespace: "custom", key: "category_img") {
//       id
//       namespace
//       key
//       type
//       value
//     }
//     compare: metafield(namespace: "custom", key: "compare") {
//       id
//       namespace
//       key
//       type
//       value
//     }
//   }
// }
//   `;

//     const response = await fetch('/api/2026-07/graphql.json', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//             query,
//             variables: {
//                 handle
//             }
//         })
//     });

//     const result = await response.json();
// console.log(result)
//     return result.data.collection.products.nodes;
// }
const isSmallScreen = window.innerWidth <= 768;

var productSelect1 = document.getElementById('ProductSelect1');
var productSelect2 = document.getElementById('ProductSelect2');
var productSelect3 = document.getElementById('ProductSelect3');

let productImg1 = document.getElementById('ProductImage1');
let productImg2 = document.getElementById('ProductImage2');
let productImg3 = document.getElementById('ProductImage3');


var products = window.products;// await getCollectionProducts('style-wig-test');

products.forEach(p => {
    productSelect1.add(new Option(p.title, p.id))
    productSelect2.add(new Option(p.title, p.id))
    if (!isSmallScreen)
        productSelect3.add(new Option(p.title, p.id))
});

window.otherColors=[{ name: "Dark Brown",value: "Dark Brown"}, {name : "Medium Brown", value: "Medium Brown"},{ name:"Light Brown", value:"Light Brown"}];

function fillProduct(product, col) {
    let productImg = document.getElementById('ProductImage' + col);
    if (productImg)
        productImg.setAttribute('src', product.categoryImg);

    let productImg2 = document.getElementById('ProductImage2' + col);
    if (productImg2)
        productImg2.setAttribute('src', product.categoryImg);

    let desc = document.getElementById('ProductDesc' + col);
    if (desc) {
        desc.innerHTML = product.collectionDesc;
    }

    let shopButton = document.getElementById("ProductShop" + col);
    if (shopButton)
        shopButton.setAttribute('href', '/products/' + product.handle)

    let selectShopButton = document.getElementById("ProductSelectShop" + col);
    if (selectShopButton)
        selectShopButton.setAttribute('href', '/products/' + product.handle)

    var table = document.getElementById("prices" + col);

    var lengths = ['6', '8', '10', '12', '14', '16'];

    if (table) {
        Array.from(table.rows).forEach(row => {
            if (!row.querySelector('th')) {
                row.remove();
            }
        });

        let productLengths = product.compare.prices.map(x => x.length.replace(' inch', ''));
        const ls = [...new Set([...lengths, ...productLengths])]
            .sort((x, y) => Number(x) - Number(y))
            .slice(0, 6);

        ls.forEach(l => {
            var p = product.compare.prices.find(x => x.length.startsWith(l));
            if (p) {
                var newRow = table.insertRow(-1);
                var cell1 = newRow.insertCell(0);
                var cell2 = newRow.insertCell(1);
                var cell3 = newRow.insertCell(2);

                cell1.textContent = p.length.replace("inch", '"');
                cell2.textContent = p.dark.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    maximumFractionDigits: 0
                });
                if (p.light)
                    cell3.textContent = p.light.toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        maximumFractionDigits: 0
                    });
            }
            else {
                var newRow = table.insertRow(-1);
                var cell1 = newRow.insertCell(0);
                var cell2 = newRow.insertCell(1);
                var cell3 = newRow.insertCell(2);

                cell1.textContent = l + ' "';
                cell2.textContent = '-';
                cell3.textContent = '-';
            }
        })

    }

    let t = document.getElementById('ProductTitle' + col);
    if (t)
        t.innerHTML = product.title;

    let h = document.getElementById('HairTitle' + col);
    if (h) {
        var hair = product.collectionHair || '';

        if (hair) {
            hair = hair.replace(' Hair', '').trim();
            h.innerHTML = hair;
            let hairImg = document.getElementById("HairImage" + col);
            if (hairImg)
                hairImg.setAttribute('src', window.hairImages[hair])

            let hairDes = document.getElementById("HairDesc" + col);
            if (hairDes)
                hairDes.innerHTML = product.compare.hair_texture?.replaceAll('<br>', '')
        }

    }


    if (product.compare) {

        let rawImg = document.getElementById("RawImage" + col)
        if(rawImg)
            rawImg.setAttribute('src', product.compare.rawimage)

        let headImg = document.getElementById("HeadImage" + col)
        if(headImg)
            headImg.setAttribute('src', product.compare.headimage)

        let baseSize = document.getElementById("BaseSize" + col)
        if(baseSize)
            baseSize.innerHTML= 'Base Size ' + product.compare.base_size;

        let hvt = document.getElementById('HairVolume' + col);
        if (hvt)
            hvt.innerHTML = product.compare.volume || '';
        // let hvd = document.getElementById('HairVolumeDesc' + col);
        // if (hvd)
        //     hvd.innerText = product.compare.HairVolumeDesc || '';

        let capHairline = document.getElementById("CapHairline" + col)
        if (capHairline)
            capHairline.innerHTML = product.compare.caphairline;
        // let capHairlineDesc = document.getElementById("CapHairlineDesc" + col)
        // if (capHairlineDesc)
        //     capHairlineDesc.innerText = product.compare.CapHairlineDesc;

        let CapTop = document.getElementById("CapTop" + col)
        if (CapTop)
            CapTop.innerHTML = product.compare.captop;
        // let CapTopDesc = document.getElementById("CapTopDesc" + col)
        // if (CapTopDesc)
        //     CapTopDesc.innerText = product.compare.CapTopDesc;

        let CapBack = document.getElementById("CapBack" + col)
        if (CapBack)
            CapBack.innerHTML = product.compare.capback;
        // let CapBackDesc = document.getElementById("CapBackDesc" + col)
        // if (CapBackDesc)
        //     CapBackDesc.innerText = product.compare.CapBackDesc;

        let capSectionSize = document.getElementById('CapSectionSize' + col)
        if(capSectionSize)
            capSectionSize.innerHTML = product.compare.base_size_title || product.compare.base_size;

        let CapDesc = document.getElementById("CapDesc" + col)
        if (CapDesc)
            CapDesc.innerHTML = product.compare.base_size_description;

        let styling = document.getElementById('Styling' + col);
        if (styling)
            styling.innerHTML = product.compare.styling_features;

        let color = document.getElementById('Color' + col);
        if (color) {
            color.innerHTML = '';
            let total = document.createElement('h3')
            total.innerText = product.colorOptions.length + ' Colors';
            color.append(total);

            setColors(color, "Brunette", window.brunetteColors, product.colorOptions);
            setColors(color, "Blonde", window.blondeColors, product.colorOptions)
            setColors(color, "Red", window.redColors, product.colorOptions)
            setColors(color, "", window.otherColors, product.colorOptions)
        }
    
    }
}

fillProduct(products[0], 1);
fillProduct(products[1], 2);
fillProduct(products[2], 3);

function setColors(el, group, groupColors, values) {

    let result = groupColors.filter(item => values.includes(item.value));
    if (result.length > 0) {

        if(group){
            let h = document.createElement('p');
            h.innerText = group + ':';
            h.classList = "color-title";
             el.append(h);
        }      

        let colors = "";
        result.forEach(c => {
            if(c.value != c.name)
                colors += `${c.value} - ${c.name}<br/>`;
            else
                colors += `${c.name}<br/>`
        })

        let p = document.createElement('p');
        p.innerHTML = colors;
       
        el.append(p);
    }
}


function changeProduct(productId, el) {
    let product = window.products.find(x => x.id == productId)
    fillProduct(product, el.id.slice(-1))
}
// productSelect1.addEventListener('change', function () {
//     const value = this.value; // 选中值
//     changeProduct(value, this)
// });
// productSelect2.addEventListener('change', function () {
//     const value = this.value; // 选中值
//     changeProduct(value, this)
// });
// productSelect3.addEventListener('change', function () {
//     const value = this.value; // 选中值
//     changeProduct(value, this)
// });

productSelect1.selectedIndex = 0;
productSelect2.selectedIndex = 1;
// if(!isSmallScreen)
productSelect3.selectedIndex = 2;


const productSelects = [productSelect1, productSelect2, productSelect3];
const previousValues = new Map(
    productSelects.map(select => [select, select.value])
);

function handleProductChange() {
    const currentSelect = this;
    const previousValue = previousValues.get(currentSelect);

    const duplicateSelect = productSelects.find(
        select => select !== currentSelect && select.value === currentSelect.value
    );

    if (duplicateSelect) {
        duplicateSelect.value = previousValue;
        changeProduct(duplicateSelect.value, duplicateSelect);
        previousValues.set(duplicateSelect, duplicateSelect.value);
    }

    changeProduct(currentSelect.value, currentSelect);
    previousValues.set(currentSelect, currentSelect.value);
}

productSelect1.addEventListener('change', handleProductChange);
productSelect2.addEventListener('change', handleProductChange);
productSelect3.addEventListener('change', handleProductChange);

const submenu = document.querySelector('.fixed-sub-menu');

if (submenu) {
    const ph = document.createElement('div');
    ph.style.display = 'none'; // 页面加载时绝不占空间
    submenu.parentNode.insertBefore(ph, submenu);

    let top = 0;
    let menuHeight = 500;
    let pinned = false;

    function measure() {
        const wasPinned = submenu.classList.contains('sticky');

        if (wasPinned) submenu.classList.remove('sticky');

        top = submenu.getBoundingClientRect().top + window.scrollY;
        // menuHeight = submenu.getBoundingClientRect().height;        

        if (wasPinned) submenu.classList.add('sticky');
    }

    function onScroll() {

        if(menuHeight > 1000)
            return;

        const shouldPin = window.scrollY >= top;
        if (shouldPin === pinned) return;

        pinned = shouldPin;
        submenu.classList.toggle('sticky', pinned);

        // 只有菜单 fixed 后才用占位补回它原来的高度
        ph.style.display = pinned ? 'block' : 'none';
        ph.style.height = pinned ? `${menuHeight}px` : '0';
    }

    measure();
    onScroll();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
}

